import { render, staticRenderFns } from "./menu-bar-nut.vue?vue&type=template&id=5563f59f&"
import script from "./menu-bar-nut.vue?vue&type=script&lang=js&"
export * from "./menu-bar-nut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports